import axios from "axios";
import { API } from "@/lib/api";

export function getRingSession() {
  try {
    return JSON.parse(localStorage.getItem("ring_session") || "null");
  } catch {
    return null;
  }
}

const ringApi = axios.create({ baseURL: API });
ringApi.interceptors.request.use((cfg) => {
  const s = getRingSession();
  if (s?.token) cfg.headers.Authorization = `Bearer ${s.token}`;
  return cfg;
});

export default ringApi;
